module.exports = __webpack_public_path__ + "media/images/gallery/constellations/bootes/boo_gc-e269dad3cafe5cdaf17b38022f9c74d1.gif";